module.exports = "<div class=\"form-grid__col form-grid__col__label\"> <label class=form-grid__label>Status</label> <dt-help-icon message-key=help_icon_advanced_search_status></dt-help-icon> </div> <div class=form-grid__col> <md-checkbox ng-repeat=\"notification in $ctrl.notifications\" ng-checked=$ctrl.exists(notification) ng-click=$ctrl.toggle(notification) class=md-default-theme ng-class=\"{'space-m-r-l': !$last}\" aria-label=checkbox> <span class=md-caption>{{ notification.title }}</span> </md-checkbox> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-status/thing-status.html
// module id = OiHR
// module chunks = 1